/* global bocAmchart4, am4core, am4charts */
/* eslint-disable id-length */

/**
 * Overlays customized bullets with modified properties like shape and color
 *
 * @param {Object} chart - The chart object
 * @param {Object[]} modifiedBullets - An array of objects containing customized-bullet properties
 * @param {number} modifiedBullets.x - x-coordinate of modified bullet
 * @param {number} modifiedBullets.y - y-coordinate of modified bullet
 * @param {(string|number)} modifiedBullets.color - color of modified bullet
 * @param {string} modifiedBullets.shape - shape of modified bullet
 * @param {string} modifiedBullets.series - existing series that modified bullet belongs to
 * @returns {void}
 */
bocAmchart4.customizeBullet = function (chart, modifiedBullets) {
    // hide original bullet first and set modified bullet's hide/show legend events
    bocAmchart4.setVisibilityEvents(chart, modifiedBullets);

    // set defaults
    let radius = 8, width = 14, height = 14;

    // Get value of data-defaultType (scatter, marker, bullet)
    let chartContainerDom = chart.svgContainer.htmlElement;
    let bocChartElement = chartContainerDom.closest('boc-chart');
    let defaultType;

    if (bocChartElement) {
        defaultType = bocChartElement.getAttribute('defaultType') || bocChartElement.getAttribute('defaulttype');
    }

    // Get new bullet dimensions from existing bullets for each bullet type
    for (let i = 0; i < chart.series.values.length; i++) {
        if (typeof chart.series.getIndex(i).bullets.getIndex(0) !== "undefined") {
            let bulletContainer = chart.series.getIndex(i).bullets.getIndex(0).children.getIndex(0);

            if (bulletContainer.className === "Rectangle") {
                // note: diamond is also a rectangle
                width = bulletContainer.pixelWidth;
                height = bulletContainer.pixelHeight;
            } else if (bulletContainer.className === "Circle") {
                radius = bulletContainer.radius;
            }

        }

    }

    // Create a new series for each new bullet
    modifiedBullets.forEach(property => {
        let newSeries = chart.series.push(new am4charts.XYSeries());
        newSeries.dataFields.valueX = "x";
        newSeries.dataFields.valueY = "y";
        newSeries.name = property.series + "_mod";
        newSeries.hiddenInLegend = true;

        // Bind the data
        newSeries.data = [{
            x: property.x,
            y: property.y,
            "bullet": bocAmchart4.createBulletSVG(property, height, width, radius, defaultType)
        }];

        // Create/Draw new bullet with data-bound SVG
        let bullet = newSeries.bullets.push(new am4charts.Bullet());
        let image = bullet.createChild(am4core.Image);
        image.propertyFields.href = "bullet";
        image.horizontalCenter = "middle";
        image.verticalCenter = "middle";
    });

};

/**
 * Helper function that creates an SVG representation of a bullet based on specified properties.
 *
 * @param {Object} property - The properties for the bullet entered by user
 * @param {string} property.shape - The shape of the bullet ('square', 'diamond', or 'circle')
 * @param {string} property.color - The fill color of the bullet
 * @param {number} height - The height of the bullet
 * @param {number} width - The width of the bullet
 * @param {number} radius - The radius of the bullet (used for circles)
 * @param {string} defaultType - The data-defaultType (bullet, scatter, marker)
 * @returns {string} The base64-encoded SVG image as a data URL
 */
bocAmchart4.createBulletSVG = function (property, height, width, radius, defaultType) {
    let bulletSVG;
    let color;
    let borderColor = "#ffffff";

    // validate color input
    if (typeof property.color === 'number' && property.color >= 0 && property.color <= bocAmchart4.bocColors.length) {
        color = bocAmchart4.bocColors[property.color];
    } else if (typeof property.color === 'string') {
        color = property.color;
    }

    // modify border color for scatter and marker
    if (defaultType === "scatter" || defaultType === "marker") {
        borderColor = color;
    }

    switch (property.shape) {
        case 'square':
            bulletSVG = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                        <g class="amcharts-Sprite-group amcharts-Rectangle-group" stroke-width="2" fill="${color}" stroke="${borderColor}">
                            <rect class="amcharts-Rectangle" x="${(50 - width) / 2}" y="${(50 - height) / 2}" width="${width}" height="${height}"></rect>
                        </g>
                    </svg>`;
            break;
        case 'diamond':
            bulletSVG = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                        <g class="amcharts-Sprite-group amcharts-Rectangle-group" stroke-width="2" fill="${color}" stroke="${borderColor}" transform="translate(25,25) rotate(45)">
                            <rect class="amcharts-Rectangle" width="${width}" height="${height}" transform="translate(-${width / 2}, -${height / 2})"></rect>
                        </g>
                    </svg>`;
            break;
        default:
            // circle is default
            bulletSVG = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                        <g class="amcharts-Sprite-group amcharts-Circle-group" fill="${color}" stroke="${borderColor}">
                            <circle class="amcharts-Circle" cx="25" cy="25" r="${radius}"></circle>
                        </g>
                    </svg>`;
            break;
    }
    return `data:image/svg+xml;charset=utf-8;base64,${btoa(bulletSVG)}`;
};

/**
 * Helper function that sets show/hide events for modified bullets. Also hides the original bullet.
 *
 * NOTE: This function needs to be run BEFORE customizeBullet otherwise it will hide the new bullet(s)
 *
 * @param {Object} chart - The chart object
 * @param {Object[]} modifiedBullets - An array of objects containing customized-bullet properties
 * @param {number} modifiedBullets.x - x-coordinate of modified bullet
 * @param {number} modifiedBullets.y - y-coordinate of modified bullet
 * @returns {void}
 */
bocAmchart4.setVisibilityEvents = function (chart, modifiedBullets) {
    chart.series.each(function (baseSeries) {
        // Event for when the base series is hidden (via legend toggle)
        baseSeries.events.on("hidden", function () {
            chart.series.each(function (diffSeries) {
                if (diffSeries.name === baseSeries.name + "_mod") {
                    // hide the modified series/bullets
                    diffSeries.hide();
                }
            });
        });

        // Event for when the base series is shown (via legend toggle)
        baseSeries.events.on("shown", function () {
            chart.series.each(function (diffSeries) {
                if (diffSeries.name === baseSeries.name + "_mod") {
                    // show the modified series/bullets
                    diffSeries.show();
                }
            });
        });

        // Use Fill adapter to hide original bullet
        if (baseSeries.bullets && baseSeries.bullets.length > 0) {
            let bullet = baseSeries.bullets.getIndex(0);
            bullet.adapter.add("fill", (fill, target) => {
                for (let index = 0; index < modifiedBullets.length; index++) {
                    if (target.dataItem.valueX === modifiedBullets[index].x && target.dataItem.valueY === modifiedBullets[index].y) {
                        // hide 'original' bullet
                        target.disabled = true;
                        break;
                    }
                }
                return fill;
            });
        }

    });

};

/**
 * Sets custom bullets on chart based on shortcode parameters
 * Parses data-customBullet0x, data-customBullet0y, etc. parameters and calls customizeBullet with collected data
 *
 * @param {Object} chart - The chart object
 * @returns {void}
 */
bocAmchart4.setCustomBulletsFromShortcode = function (chart) {
    let bulletIndex = 0;
    let customBullets = [];

    // Loop through bullets until we don't find the required x parameter
    // Parameters are lowercased during processing, so use lowercase names
    while (chart.bocSettings.args.hasOwnProperty('custombullet' + bulletIndex + 'x')) {
        let prefix = 'custombullet' + bulletIndex;

        // Required parameters
        let x = chart.bocSettings.args[prefix + 'x'];
        let y = parseFloat(chart.bocSettings.args[prefix + 'y']);
        let series = chart.bocSettings.args[prefix + 'series'];

        // Optional parameters with defaults
        let color = chart.bocSettings.args[prefix + 'color'] || '';
        let shape = chart.bocSettings.args[prefix + 'shape'] || 'round';

        // Convert x to number if it's a numeric string (but not a date)
        if (typeof x === 'string' && !isNaN(x) && x.indexOf('-') === -1) {
            x = parseFloat(x);
        }

        // If color is not provided, find the series index and use that as default color
        if (!color) {
            // Find the series index by matching the series name
            let seriesIndex = 0;
            for (let i = 0; i < chart.series.length; i++) {
                if (chart.series.getIndex(i).name === series) {
                    seriesIndex = i;
                    break;
                }
            }
            color = seriesIndex;
        } else {
            if (!isNaN(color)) {
                color = parseInt(color);
            }
        }

        // Create custom bullet object
        let bulletObj = {
            x: x,
            y: y,
            color: color,
            shape: shape,
            series: series
        };

        customBullets.push(bulletObj);
        bulletIndex++;
    }

    // If we found any custom bullets, add them all at once using the existing customizeBullet function
    if (customBullets.length > 0) {
        bocAmchart4.customizeBullet(chart, customBullets);
    }
}
;
